import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'informed'

import { Modal } from 'components/Modal'
import { Text } from 'components/forms'
import Button from 'components/Button'
import Divider from 'components/Divider'

const MutateRowForm = ({ data = {}, columns, onChangeRow, inModal, addBtnText, updateBtnText }) => {
	const rowData = data || {},
		isUpdatingRow = Object.keys(rowData).length // Otherwise adding row
	const rowForm = (
		<Form onSubmit={onChangeRow} render ={({ formApi, formState }) => (
			<Fragment>
				{columns.map((col, i) => (
					<Text
						field={col.accessor}
						defaultValue={rowData[col.accessor] || null}
						label={col.accessor === 'id' ? null : col.Header}
						hidden={col.accessor === 'id'}
						inline
						className={col.accessor === 'id' ? 'hidden-field' : ''}
						key={i} />)
				)}
				<Divider />
				<Button text={isUpdatingRow ? updateBtnText : addBtnText} />
			</Fragment>
		)}/>
	)

	return(
		<div>
			{inModal || isUpdatingRow ?
				<Modal unmount={() => onChangeRow()}>
					{rowForm}
				</Modal> :
				<Fragment>
					<Divider />
					{rowForm}
				</Fragment>
			}
		</div>
	)
}

MutateRowForm.propTypes = {
	data: PropTypes.object, // Empty object if adding row, row data object if editing row
	columns: PropTypes.array.isRequired,
	onChangeRow: PropTypes.func.isRequired,
	inModal: PropTypes.bool,
	addBtnText: PropTypes.string,
	updateBtnText: PropTypes.string
}

MutateRowForm.defaultProps = {
	inModal: true,
	addBtnText: 'Hinzufügen',
	updateBtnText: 'Aktualisieren'
}

export default MutateRowForm
